module.exports = __webpack_public_path__ + "img/icon-zjzx.462faea0.png";